module.exports = __webpack_public_path__ + "static/assets/ece0b0d18256834e7f7f3a3b0df8d7e6.svg";